<template>
  <img
    v-if="src && !isError"
    :src="src"
    alt=""
    :style="style"
    @error="error"
    @load="load"
  >
  <img v-else-if="altsrc"
    :src="altsrc"
    alt=""
    :style="style"
   />
  <span
    v-else
    :style="'width:'+ style.width + ';height:' + style.height +';line-height:' + style.height"
    class="no-head-img"
  >
    <span class="align-center" style="justify-content: center;width: 100%;height: 100%;">
      <span v-if="name">{{ name.substr(name.length - 2, 2) }}</span>
    </span>
  </span>
</template>
<script>
export default {
  name: 'headImg',
  props: {
    src: {
      type: String,
      default: '',
    },
    size: {
      type: [String, Number],
      default: '50px',
    },
    name: {
      type: String,
      default: '',
    },
    altsrc: {
      default: ''
    }
  },
  data() {
    return {
      isError: false
    }
  },
  computed: {
    style () {
      let size = this.size
      if (this.isNumber(size)) {
        size += 'px'
      }
      return {
        width: size,
        height: size,
      }
    }
  },
  methods: {
    error() {
      this.isError = true;
    },
    load() {
      this.$emit('on-load');
    },
    isNumber(val) {
      let regPos = /^\d+(\.\d+)?$/; // 非负浮点数
      let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
      return regPos.test(val) || regNeg.test(val);
    },
  },
};
</script>
<style scoped>
.no-head-img {
  background: #3389FF;
  display: inline-block;
  color: white;
  text-align: center;
  overflow: hidden;
  font-size: 12px;
  border-radius: 50%;
}
</style>
